import type { ChatMessage } from '@/contexts/chat-context'

export function hasAssistantToolErrors(message: ChatMessage): boolean {
	return Boolean(message.toolCalls?.some((tc) => tc.status === 'error'))
}

export function isFailedAssistantMessage(message: ChatMessage): boolean {
	return message.role === 'assistant' && !message.isStreaming && Boolean(message.content?.startsWith('Error:'))
}

/**
 * True when the user can retry without retyping. Stream failures always can;
 * tool errors only warrant it when the answer never materialized — a recovered
 * tool error followed by a real answer isn't a failure worth retrying.
 */
export function canRetryAssistantMessage(message: ChatMessage): boolean {
	if (message.role !== 'assistant' || message.isStreaming) return false
	if (isFailedAssistantMessage(message)) return true
	return hasAssistantToolErrors(message) && !message.content?.trim()
}
